import React, { useState } from "react";
import styles from "./DiscountModel.module.scss";
import { useSelector, useDispatch } from "react-redux";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import {
  setDiscountType,
  setDiscountAmount,
} from "../../../../redux/actions/tickets/tickets";

interface IProps {
  handleCancelDiscount: any;
  setAndClose: any;
}
const DiscountModel: React.FC<IProps> = ({
  handleCancelDiscount,
  setAndClose,
}) => {
  const [discountType, setdiscountType] = useState("");
  const [discountAmount, setdiscountAmount] = useState(0);
  console.log(discountAmount);

  const dispatch = useDispatch();
  const state = useSelector((state: any) => state.ticketReducer);
  console.log(state);

  const handleDiscount = () => {
    dispatch(setDiscountType(discountType));

    const discountPercentage = discountAmount / 100;
    console.log(discountPercentage);

    discountType === "Percentage"
      ? dispatch(setDiscountAmount(discountPercentage))
      : dispatch(setDiscountAmount(discountAmount));
    //  dispatch(setDiscountAmount(discountAmount));
  };
  return (
    <div className={styles.overlay_model}>
      <div className={styles.success_model}>
        <div className={styles.success_model_container}>
          {/* <h1>{ticketItems.length}</h1> */}
          <FormControl
            sx={{
              m: 1,
              minWidth: 200,
            }}
          >
            <InputLabel id="demo-simple-select-helper-label">
              Discount Type
            </InputLabel>
            <Select
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              value={discountType}
              label="Walk In"
              onChange={(e: any) => setdiscountType(e.target.value)}
            >
              <MenuItem value={"Percentage"}>Percentage</MenuItem>

              <MenuItem value={"Amount"}>Amount</MenuItem>

              {/* <MenuItem value={30}>Thirty</MenuItem> */}
            </Select>
          </FormControl>

          {discountType === "Percentage" ? (
            <>
              <label htmlFor="">Enter discount %</label>
              <input
                type="number"
                placeholder="Enter discount %"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setdiscountAmount(parseInt(e.target.value))
                }
              />
            </>
          ) : discountType === "Amount" ? (
            <>
              <label htmlFor="">Enter discount amount</label>
              <input
                type="number"
                placeholder="Enter discount amount"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setdiscountAmount(parseInt(e.target.value))
                }
              />
            </>
          ) : (
            <h1> Please select a discount type</h1>
          )}
          <div className={styles.btn_container}>
            <button
              onClick={() => {
                handleDiscount();
                setAndClose();
              }}
            >
              SET DISCOUNT
            </button>
            <button onClick={handleCancelDiscount}>CANCEL DISCOUNT</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiscountModel;
